import React from 'react';
import { AppBar, IconButton, Toolbar, Typography} from '@material-ui/core';
import {Menu, ExitToApp} from '@material-ui/icons';

export default function Header(props) {
    const {classes, onSidebarOpen} = props;

    const logout = () => { 
        window.localStorage.clear();
        window.location.href = '/login'; };

    return (
        <div>
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                <IconButton 
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={onSidebarOpen}
                    className={classes.menuButton}
                >
                    <Menu/>
                </IconButton> 
                <img src={require("../../assets/logo_small.png")}></img>
                <Typography variant="h6" noWrap className={classes.title}>
                CDL - Showroom Appointment Booking
                </Typography>
                <IconButton  color="inherit" onClick={() => logout()}><ExitToApp/></IconButton>
                </Toolbar>
            </AppBar>
        </div>
    )
}
 